import {recordSchema} from '@lightweightform/storage';
import {unionFormSchema} from './union-form/union-form.schema';

/**
 * App schema.
 */
export const appSchema = recordSchema({
  'union-form': unionFormSchema,
});
